import { render, staticRenderFns } from "./party-info.vue?vue&type=template&id=0dd53926&"
import script from "./party-info.vue?vue&type=script&lang=js&"
export * from "./party-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports